const Schedule = () => import('@pages/inoutHospital/Schedule')
const Detail = () => import('@pages/inoutHospital/Schedule/Detail')
const Order = () => import('@pages/inoutHospital/Schedule/Order')

export const inoutHospital = [
  {
    path: '/inoutHospital/schedule',
    name: 'InoutHospitalSchedule',
    component: Schedule,
    meta: {}
  },
  {
    path: '/inoutHospital/detail/:id',
    name: 'InoutHospitalScheduleDetail',
    component: Detail,
    meta: {}
  },
  {
    path: '/inoutHospital/order/:id',
    name: 'InoutHospitalScheduleOrder',
    component: Order,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/inoutHospital.route.js